import styled from '@emotion/styled';
import { borderRadii } from 'app/spacing';
import TableScrollContainer from '__components/Tables/ScrollContainer';
import BasicModal from '__components/Modals/presets/BasicModal';

export const StyledLinkWrapper = styled.div`
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
`;

export const TableWrapper = styled.div`
  width: 100%;
  flex: 1;
  background-color: var(--color-background-white);
  border-radius: ${borderRadii.small};
  overflow-y: hidden;
  flex-direction: column;
  position: relative;
  height: 100%;
  > div {
    position: relative;
    height: 100%;
  }
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  flex: 0 0 45px;
  padding-top: 20px;
`;

export const StyledTableScrollContainer = styled(TableScrollContainer)`
  height: 100%;
`;

export const StyledModal = styled(BasicModal)`
  && .modal-body {
    overflow: visible;
  }
`;
